import React, { useEffect, useState } from "react";
import socket from "../../socket";
import { getUser } from "../../auth";
import ResumenFacturacionTable from "../components/ResumenFacturacionTable";

const URL = process.env.REACT_APP_API_URL;

export default function ResumenFacturacion() {
  const [data, setData] = useState(null);
  
  const fetchResumen = () => {
    const user = getUser();
    fetch(`${URL}/api/sales/summary/today/`, {
      headers: {
        "X-Empresa-Id": user?.empresa_id,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al obtener resumen");
        return res.json();
      })
      .then(setData)
      .catch((err) => {
        console.error(err);
        setData({ caja: 0, cuenta: 0, total: 0 });
      });
  }

  useEffect(() => {
    fetchResumen();
  }, []);

  useEffect(() => {
    socket.on("venta_creada", fetchResumen);
    socket.on("venta_borrada", fetchResumen);
    socket.on("venta_editada", fetchResumen);

    return () => {
      socket.off("venta_creada", fetchResumen);
      socket.off("venta_borrada", fetchResumen);
      socket.off("venta_editada", fetchResumen);
    };
  }, []);

  return (
    <ResumenFacturacionTable data={data} />
  );
}
